import styled from "styled-components"
import Doc from "../../../../models/document"
import MicrosoftIcon from "../../../atoms/icons/microsoft-icon"
import { DownloadIcon } from "../../../atoms/icons"
import ActionButton from "../../../atoms/buttons/action-button"
import ClickIcon from "../../../atoms/icons/click-icon"

interface DocumentCardProps {
    document: Doc
    handleView?: (_document: Doc) => void
    handleSelect?: (_document: Doc) => void
    loading?: boolean
}


const DocumentCard = ({ document, handleView, handleSelect, loading }: DocumentCardProps) => {
    return <div className="document-card">
        <MicrosoftIcon />
        <div className="document-card-info">
            <div className="document-card-name" onClick={() => !loading && handleView && handleView(document)}>{document.name}</div>
        </div>
        {
            handleView &&
            <ActionButton type="button" title="Download a preview copy (file name starts with PREVIEW)" disabled={loading} onClick={() => handleView(document)}>
                {loading ? 'Preparing...' : 'Download Preview'} <DownloadIcon />
            </ActionButton>
        }
        {
            handleSelect &&
            <button onClick={() => handleSelect(document)}>
                <ClickIcon />
            </button>
        }
    </div>
}

export default DocumentCard